import { motion, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";

const ProgressBar = ({ title, percentage }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-50px" });
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (isInView) {
            setWidth(percentage);
        }
    }, [isInView, percentage]);

    return (
        <div className="mb-6" ref={ref}>
            <div className="flex justify-between mb-2">
                <h3 className="text-white font-medium text-sm tracking-wide">{title}</h3>
                <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: isInView ? 1 : 0 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                    className="text-accent-cyan font-bold text-sm"
                >
                    {percentage}%
                </motion.span>
            </div>
            <div className="w-full h-2 bg-dark-800 rounded-full overflow-hidden border border-white/5">
                <motion.div
                    className="h-full bg-gradient-to-r from-accent-blue via-accent-cyan to-accent-purple relative"
                    initial={{ width: 0 }}
                    animate={{ width: `${width}%` }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                >
                    <div className="absolute top-0 right-0 bottom-0 w-10 bg-white/20 blur-[2px]"></div>
                </motion.div>
            </div>
        </div>
    );
};

export default ProgressBar;
